import { render } from "./app-panel.vue?vue&type=template&id=4b409db7"
import script from "./app-panel.vue?vue&type=script&lang=js"
export * from "./app-panel.vue?vue&type=script&lang=js"

import "./app-panel.vue?vue&type=style&index=0&id=4b409db7&lang=scss"

import exportComponent from "/Users/ns/Desktop/entwicklung/github/corpred_desk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__